export default function RequestBenefits() {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: 'Save Time',
      description: 'No more endless scrolling through listings or visiting multiple dealerships. We do the legwork.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Save Money',
      description: 'Our flat $500 fee is transparent. Plus, we negotiate dealer prices down — often saving you thousands.'
    },
    {
      icon: 'ri-shield-user-line',
      title: 'No Dealer Pressure',
      description: 'Skip the sales tactics, upsells, and F&I office games. We work for you, not the dealer.'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Expert Inspection',
      description: 'Every vehicle is thoroughly inspected before we present it to you. No surprises, no hidden issues.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Delivered to You',
      description: 'We bring the vehicle to your door anywhere on the Oregon Coast or SW Washington.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Full Transparency',
      description: 'You see every detail: inspection reports, pricing breakdown, and vehicle history. No secrets.'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Use a Broker?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Because car buying should be easy, transparent, and on your terms.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center justify-center w-14 h-14 rounded-full bg-amber-100 mb-4">
                <i className={`${benefit.icon} text-2xl text-amber-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}